// Restarts the auto-switch CSS animations each time the server re-renders
// this element with `data-auto-switched="true"`. Without this, two consecutive
// auto-switches that both render `auto_switched=true` produce no visible
// animation on the second one: morphdom doesn't change the class attribute,
// and `animation-fill-mode: forwards` leaves the element in its finished end
// state.
//
// The standard "remove class, force reflow, re-add" trick (see
// highlight_hook.js) is what re-triggers the animation.
const ANIMATED_CLASSES = [
  "animate-auto-switch-flash",
  "animate-auto-switch-text-fade",
]

function restartAnimation(rootEl, className) {
  const target = rootEl.querySelector("." + className)
  if (!target) return

  target.classList.remove(className)
  // Force reflow so the browser registers the class removal before re-adding.
  // https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Animations/Tips#run_an_animation_again
  void target.offsetWidth
  target.classList.add(className)
}

// Closes the race between picking the calc_type and submitting the form: if
// the user picks while the highlight is showing and submits before phx-change
// re-renders, the form would carry stale `user_overrode_calculation_type=false`
// and the save-path threshold logic would silently undo their pick. Flip the
// hidden input synchronously on input so any subsequent submit captures the
// override regardless of whether validate has completed.
function markOverrideOnCalcTypeChange(fieldsetEl, event) {
  if (fieldsetEl.dataset.autoSwitched !== "true") return

  const target = event.target
  if (!(target instanceof HTMLSelectElement)) return
  if (!target.name.endsWith("[calculation_type]")) return

  const hidden = fieldsetEl.querySelector(
    'input[type="hidden"][name$="[user_overrode_calculation_type]"]',
  )
  if (hidden) hidden.value = "true"
}

export const AutoSwitchFlash = {
  mounted() {
    this.handleInput = (event) => markOverrideOnCalcTypeChange(this.el, event)
    this.el.addEventListener("input", this.handleInput)
  },

  destroyed() {
    this.el.removeEventListener("input", this.handleInput)
  },

  updated() {
    if (this.el.dataset.autoSwitched !== "true") return
    ANIMATED_CLASSES.forEach((cls) => restartAnimation(this.el, cls))
  },
}
